"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTruncateAfterDash = exports.getCreateTestData = exports.getEventRowTestDataId = exports.getEventTestDataId = exports.getOutcomeTestDataId = void 0;
const testData_types_1 = require("./testData.types");
const getOutcomeTestDataId = (data) => {
    var _a, _b;
    if (typeof data === 'object') {
        return `${testData_types_1.ETestData.TestEventMarketOdd}-${(_a = data === null || data === void 0 ? void 0 : data.outcomeTypeData) === null || _a === void 0 ? void 0 : _a.marketId}-${data === null || data === void 0 ? void 0 : data.outcomeTypeId}-${(_b = data === null || data === void 0 ? void 0 : data.outcomeTypeData) === null || _b === void 0 ? void 0 : _b.name}`.replace(/ /g, '-');
    }
    return undefined;
};
exports.getOutcomeTestDataId = getOutcomeTestDataId;
const getEventTestDataId = (event) => {
    var _a;
    if (event !== undefined) {
        return `${testData_types_1.ETestData.TestEvent}-${(_a = event === null || event === void 0 ? void 0 : event.tournament) === null || _a === void 0 ? void 0 : _a.id}-${event === null || event === void 0 ? void 0 : event.id}`;
    }
    return undefined;
};
exports.getEventTestDataId = getEventTestDataId;
const getEventRowTestDataId = (event, mainOutcomeType) => {
    var _a;
    if (event !== undefined) {
        return `${testData_types_1.ETestData.TestEventRow}-${(_a = event === null || event === void 0 ? void 0 : event.tournament) === null || _a === void 0 ? void 0 : _a.id}-${event === null || event === void 0 ? void 0 : event.id}-${mainOutcomeType}`;
    }
    return undefined;
};
exports.getEventRowTestDataId = getEventRowTestDataId;
const getCreateTestData = (prefix, content) => {
    if (prefix === undefined || content === undefined) {
        return undefined;
    }
    return `${prefix}-${content.replace(/ /g, '-')}`;
};
exports.getCreateTestData = getCreateTestData;
const getTruncateAfterDash = (marketGroupId) => {
    return marketGroupId.split('-')[0];
};
exports.getTruncateAfterDash = getTruncateAfterDash;
//# sourceMappingURL=testData.js.map